import React, { FC, useState, useCallback } from 'react';
import { Visible } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';
import { useBiLogger } from '../../contexts/BILoggerContext';
import { InspirationalTemplate } from '../../domain/entities/inspirationalTemplate';

import s from './QuickViewButton.scss';
import { QuickViewModal } from '../InspirationalTemplate/QuickViewModal/QuickViewModal';
import { INSPIRATIONAL_CATEGORY_SLUG } from '../../config';

interface QuickViewButtonProps {
  template: InspirationalTemplate;
  index?: number;
}

export const QuickViewButton: FC<QuickViewButtonProps> = ({
  template,
  index,
}) => {
  const { t } = useTranslation();
  const biLogger = useBiLogger();
  const [isQuickViewModalOpen, setIsQuickViewModalOpen] = useState(false);
  const [isMediaLoadDeferred, setIsMediaLoadDeferred] = useState(true);

  const closeQuickViewModal = useCallback(
    (action: string) => () => {
      setIsQuickViewModalOpen(false);

      biLogger.reportGeneralAction({
        action,
        actionValue: 'quick_view',
        index,
        slugId: template.slug,
        templateId: template.templateId,
      });
    },
    [biLogger, index, template.slug, template.templateId],
  );

  const openQuickViewModal = useCallback(() => {
    setIsQuickViewModalOpen(true);
    setIsMediaLoadDeferred(false);
    biLogger.reportGeneralAction({
      action: 'open',
      actionValue: 'quick_view',
      index,
      slugId: template.slug,
      templateId: template.templateId,
    });
  }, []);

  const handleMouseOver = () => {
    setIsMediaLoadDeferred(false);
  };

  return (
    <>
      <button
        className={s.button}
        onClick={openQuickViewModal}
        onMouseOver={handleMouseOver}
      >
        <Visible />
        {t('app.templates.carousel.template.quickView')}
      </button>
      <QuickViewModal
        template={template}
        categorySlug={INSPIRATIONAL_CATEGORY_SLUG}
        isOpen={isQuickViewModalOpen}
        onButtonXClick={closeQuickViewModal('close_x')}
        onOutsideClick={closeQuickViewModal('close_outside')}
        onEscKeyDown={closeQuickViewModal('close_esc')}
        index={index}
        isMediaLoadDeferred={isMediaLoadDeferred}
      />
    </>
  );
};
